var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.backgroundColor]},[_c('div',{staticClass:"flex-mid m-auto"},[_c('relationship-mapping')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }